import { render, staticRenderFns } from "./ShainSettei.vue?vue&type=template&id=4626e248&scoped=true"
import script from "./ShainSettei.vue?vue&type=script&lang=js"
export * from "./ShainSettei.vue?vue&type=script&lang=js"
import style0 from "./ShainSettei.vue?vue&type=style&index=0&id=4626e248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4626e248",
  null
  
)

export default component.exports